// import React, { useState, useEffect } from "react";
// import { BsJustify } from "react-icons/bs";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useYearContext } from "../../admin/components/YearContext";

// const Clientheader = ({ openSidebar }) => {
//   const navigate = useNavigate();
//   const [username, setUsername] = useState();
//   const [email, setEmail] = useState();
//   const { yearSelected, onYearChange } = useYearContext(); // Use context for year

//   useEffect(() => {
//     const role = localStorage.getItem("role");
//     if (role !== "client") {
//       navigate("/login");
//     }
//   }, [navigate]);

//   const token = Cookies.get("token");
//   useEffect(() => {
//     if (!token) {
//       navigate("/login");
//     } else {
//       const decoded = jwtDecode(token);
//       setEmail(decoded.email);

//       if (decoded.role !== "client") {
//         navigate("/login");
//       }
//     }
//     fetchUsername();
//   }, [token, navigate]);

//   const fetchUsername = async () => {
//     try {
//       const response = await axios.get(" https://api.easytaxexperts.com/getclientusername", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       if (response.data.success) {
//         setUsername(response.data.result[0].userName);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleYearChange = (e) => {
//     const selectedYear = e.target.value;
//     onYearChange(selectedYear);
//   };

//   return (
//     <header className="invoice-header">
//       <div className="menu-icon">
//         <BsJustify className="icon" onClick={openSidebar} />
//       </div>

//       <div className="header-left d-flex gap-5 flex-start my-3">
//         <select
//           className="form-select fs-6"
//           value={yearSelected}
//           onChange={handleYearChange}
//         >
//           <option value="2025">2025</option>
//           <option value="2024">2024</option>
//           <option value="2023">2023</option>
//           <option value="2022">2022</option>
//           <option value="2021">2021</option>
//         </select>
//       </div>

//       <div className="header-right ">
//         <h6>{username}</h6>
//       </div>
//     </header>
//   );
// };

// export default Clientheader;


// import React, { useState, useEffect } from "react";
// import { BsJustify } from "react-icons/bs";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useYearContext } from "../../admin/components/YearContext";

// const Clientheader = ({ openSidebar }) => {
//   const navigate = useNavigate();
//   const token = Cookies.get("token");

//   const { yearSelected, onYearChange, generateFinancialYears } = useYearContext();

//   const [username, setUsername] = useState("");

//   useEffect(() => {
//     if (!token) return navigate("/login");

//     const decoded = jwtDecode(token);
//     if (decoded.role !== "client") return navigate("/login");

//     fetchUsername(); // fetch always on mount
//   }, [token]);

//   const fetchUsername = async () => {
//     try {
//       const response = await axios.get("https://api.easytaxexperts.com/getclientusername", {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.data.success) {
//         const name = response.data.result[0].userName;
//         setUsername(name);
//       }
//     } catch (error) {
//       console.log(error);
//       setUsername("Client");
//     }
//   };

//   const yearOptions = generateFinancialYears();

//   return (
//     <header className="invoice-header">
//       <div className="menu-icon">
//         <BsJustify className="icon" onClick={openSidebar} />
//       </div>

//       <div className="header-left d-flex gap-5 flex-start my-3">
//         <select
//           className="form-select fs-6"
//           value={yearSelected}
//           onChange={(e) => onYearChange(e.target.value)}
//         >
//           {yearOptions.map((year) => (
//             <option key={year} value={year}>
//               {year}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="header-right">
//         <h6>{username}</h6>
//       </div>
//     </header>
//   );
// };

// export default Clientheader;

import React, { useState, useEffect } from "react";
import { BsJustify } from "react-icons/bs";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useYearContext } from "../../admin/components/YearContext";

const Clientheader = ({ openSidebar }) => {
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const { 
    yearSelected, 
    onYearChange, 
    generateFinancialYears, 
    isInitialized 
  } = useYearContext();

  const [username, setUsername] = useState("");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded.role !== "client") {
        navigate("/login");
        return;
      }
    } catch (error) {
      navigate("/login");
      return;
    }

    fetchUsername();
  }, [token, navigate]);

  const fetchUsername = async () => {
    try {
      const response = await axios.get("https://api.easytaxexperts.com/getclientusername", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        const name = response.data.result[0]?.userName || "Client";
        setUsername(name);
      }
    } catch (error) {
      console.error("Error fetching username:", error);
      setUsername("Client");
    }
  };

  const yearOptions = generateFinancialYears();

  // Don't render until year is initialized
  if (!isInitialized) {
    return (
      <header className="invoice-header">
        <div className="menu-icon">
          <BsJustify className="icon" onClick={openSidebar} />
        </div>
        <div className="header-left">
          <select className="form-select fs-6" disabled>
            <option>Loading...</option>
          </select>
        </div>
        <div className="header-right">
          <h6>Loading...</h6>
        </div>
      </header>
    );
  }

  return (
    <header className="invoice-header">
      <div className="menu-icon">
        <BsJustify className="icon" onClick={openSidebar} />
      </div>

      <div className="header-left d-flex gap-5 flex-start my-3">
        <select
          className="form-select fs-6"
          value={yearSelected}
          onChange={(e) => onYearChange(e.target.value)}
        >
          {yearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="header-right">
        <h6>{username}</h6>
      </div>
    </header>
  );
};

export default Clientheader;